import type { ComponentProps } from 'react'
import { cn } from './cn.js'
import { CloseIcon, SearchIcon } from './icons.js'

export interface SearchInputProps
  extends Omit<ComponentProps<'input'>, 'value' | 'onChange' | 'size'> {
  value: string
  onValueChange: (value: string) => void
  label: string
  /** Match the surface behind the input: 'surface' on the page, 'bg' in a sheet. */
  tone?: 'surface' | 'bg'
}

/** The search box. 16px on purpose: iOS zooms toward any smaller focused input. */
export function SearchInput({
  value,
  onValueChange,
  label,
  tone = 'surface',
  className,
  placeholder = 'Ieškoti…',
  ...props
}: SearchInputProps) {
  return (
    <div className={cn('relative min-w-0 flex-1', className)}>
      <SearchIcon className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-mute" />
      <input
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        aria-label={label}
        placeholder={placeholder}
        enterKeyHint="search"
        autoComplete="off"
        className={cn(
          'h-11 w-full rounded-[var(--radius-control)] border border-line pl-9 pr-10 text-[1rem] text-ink',
          'placeholder:text-mute transition-colors duration-[140ms] focus:border-line-strong',
          tone === 'bg' ? 'bg-bg' : 'bg-surface',
        )}
        {...props}
      />
      {value !== '' && (
        <button
          type="button"
          aria-label="Išvalyti"
          onClick={() => onValueChange('')}
          className="absolute right-1 top-1/2 flex size-9 -translate-y-1/2 items-center justify-center text-mute hover:text-ink"
        >
          <CloseIcon className="size-4" />
        </button>
      )}
    </div>
  )
}
